import { render } from "./TaxAccountingEntryInfosModal.vue?vue&type=template&id=3fb87b13&scoped=true&ts=true&lang=pug"
import script from "./TaxAccountingEntryInfosModal.vue?vue&type=script&lang=ts"
export * from "./TaxAccountingEntryInfosModal.vue?vue&type=script&lang=ts"

import "./TaxAccountingEntryInfosModal.vue?vue&type=style&index=0&id=3fb87b13&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb87b13"]])

export default __exports__